import { TmBaseError } from '@/core/error/tmBaseError'

export default class TmRouterError extends TmBaseError {
  public name = 'TmRouterError'
}
